export const red = Phaser.Display.Color.HexStringToColor('#ba1f14');
export const blue = Phaser.Display.Color.HexStringToColor('#0f36d1');
export const orange = Phaser.Display.Color.HexStringToColor('#ebad03');
export const white = Phaser.Display.Color.HexStringToColor('#FFF');
export const pink = Phaser.Display.Color.HexStringToColor('#F7C2D1');
export const green = Phaser.Display.Color.HexStringToColor('#2FAC66');